import styled from 'styled-components';

export const PdfContainer = styled.div`
  canvas {
    margin: 0 auto;
    border: 1px solid #999;
  }

  .arrow-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;

      p {
        margin-bottom: 6px;
      }

      svg {
        cursor: pointer;
        margin: 0 10px;
      }
  }

  .react-pdf__Page {
    overflow: scroll;
  }
`;


export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledImg = styled.img`
  width: 100%;
`;

